<!--
	HomePage.svelte

    This is where authenticated users will arrive after login.
-->

<script>
	import { onMount } from 'svelte';
    import { push } from 'svelte-spa-router';
    import { fade } from 'svelte/transition';
    import { AccountStore } from "../../common/account";

    // TCARE components
    import TileMenu from '../../components/common/TileMenu.svelte';


    onMount(() => {
        if (!$AccountStore?.isLoggedIn) {
            push('/landing');                                  // and login
        }
    })

</script>



<style>

    .home-page section {
        position: relative;
        width: 80%;
        max-width: 1300px;
        padding: 20px 5%;
        margin: 20px auto;
        font-family: 'Manrope', sans-serif;
        /* font-family: 'Newsreader', serif; */
        user-select: none;
        border-radius: 20px;
        opacity: .9;
        background-color: var(--tcare-white);
    }

    .home-page .section-1 {
        width: 80%;
        color: var(--tcare-primary);
        background-color: var(--tcare-white);
    }

    p {
        margin: 0px;
    }
    
    @media screen and (max-width: 600px) {
        .home-page section {
            width: 100%;
            padding: 20px 30px;
            margin: 10px auto;
            user-select: none;
            border-radius: 20px;
        }
        .home-page .section-1 {
            font-size: .8em;
        }

    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }
</style>


<!-- <div class="page-content landing-page" in:fly="{{ x: -100, duration: 500 }}" out:fade="{{ duration: 250 }}"> -->
<div class="page-content home-page" in:fade="{{ duration: 250 }}" out:fade="{{ duration: 250 }}">
    <div class="spacer-h-25"></div>

    <div class="flex-row jc-center">
        <p class="fs-3 fw-100 ta-c">Welcome to TCARE Connect.</p>
    </div>

    <div class="spacer-h-25"></div>

    <section class="section-1">
        <div class="fs-1-5 ta-c">
            {#if $AccountStore?.isLoggedIn}
                Hello {$AccountStore.name} - you are now logged in to TCARE Connect
            {:else}
                Please login to continue with TCARE Connect
            {/if}
        </div>
    </section>

    <br/>
    {#if $AccountStore?.isLoggedIn}
        <TileMenu />
    {/if}

    <div class="spacer-h-50"></div>
</div>
